import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import {Logout, Menu as MenuIcon} from "@mui/icons-material";
import {Button, Chip, IconButton, Menu, MenuItem, Toolbar, Typography} from "@mui/material";
import {useUserActions} from "../../stream/authentication/service/user.actions";
import {GlobalContext} from "../state/GlobalContextProvider";
import {isBrowser, isMobile} from "react-device-detect";
import {useTheme} from "@mui/material/styles";
import {useTranslation} from "react-i18next";
import {GB, IT, FR, ES, PT} from "country-flag-icons/react/1x1";
import {useWindowSize} from "../../config/globalConfig";
import {useNavigate} from "react-router-dom";


const Header = (props: any) => {
    const {t, i18n} = useTranslation();
    const theme = useTheme();
    const {width} = useWindowSize();
    const {globalData} = useContext(GlobalContext);
    const navigate = useNavigate();
    const userActions = useUserActions();
    const [anchorElLang, setAnchorElLang] = React.useState<null | HTMLElement>(null);
    const openLang = Boolean(anchorElLang);
    const [showMenu, setShowMenu] = useState(isMobile || width <= 635);
    // @ts-ignore
    const env = window?.appConfig?.ENV;

    const handleClickLang = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElLang(event.currentTarget);
    };
    const handleCloseLang = () => {
        setAnchorElLang(null);
    };
    const handleChangeLang = (lang: string) => {
        i18n.changeLanguage(lang);
        handleCloseLang();
    }
    const handleDrawerClick = () => {
        props.setMenuIsOpen(!props.menuIsOpen);
    }

    const renderSelectedLang = () => {
        switch (i18n.language) {
            case 'it':
            case 'it-IT':
                return (<IT style={{borderRadius: '50%'}} title={'Italiano'} width={20} height={20}/>)
            case 'fr':
            case 'fr-FR':
                return (<FR style={{borderRadius: '50%'}} title={'Francese'} width={20} height={20}/>)
            case 'es':
            case 'es-ES':
                return (<ES style={{borderRadius: '50%'}} title={'Español'} width={20} height={20}/>)
            case 'pt':
            case 'pt-PT':
                return (<PT style={{borderRadius: '50%'}} title={'Español'} width={20} height={20}/>)
            case 'en':
            default:
                return (<GB style={{borderRadius: '50%'}} title={'English'} width={20} height={20}/>)
        }
    }

    useEffect(() => {
        setShowMenu(isMobile || width <= 635);
    }, [isMobile, width]);

    return (
        <Box>
            <AppBar position="fixed" sx={{zIndex: (theme) => theme.zIndex.drawer + 1}}>
                <Toolbar>
                    {!props.isExternal && showMenu &&
                        <IconButton sx={{
                            color: theme.palette.primary.contrastText,
                            marginRight: '8px'
                        }} onClick={handleDrawerClick}>
                            <MenuIcon/>
                        </IconButton>
                    }
                    <Box sx={{minWidth: '120px'}} onClick={() => {
                        if (!props.isExternal) {
                            navigate('/')
                        }
                    }}>
                        <img alt="logo" src={"/images/logo-white.svg"}/>
                    </Box>

                    {(env && env !== 'PROD') &&
                        <Box ml={1}>
                            <Chip sx={{color: 'white', fontWeight: 'bold'}} color={'secondary'} label={env}/>
                        </Box>
                    }

                    <Box sx={{flexGrow: 1}}/>
                    <Box mr={1}>
                        <Typography variant={'h6'} color={'inherit'}>
                            {globalData?.user?.username}
                        </Typography>
                    </Box>
                    <Box>
                        <IconButton
                            onClick={handleClickLang}
                            aria-controls={openLang ? 'account-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={openLang ? 'true' : undefined}
                        >
                            {renderSelectedLang()}
                        </IconButton>
                        {!props.isExternal && <IconButton color={'inherit'} onClick={userActions.logout}>
                            <Logout fontSize="small"/>
                        </IconButton>}
                    </Box>
                </Toolbar>
            </AppBar>
            <Menu
                anchorEl={anchorElLang}
                id="account-menu"
                open={openLang}
                onClose={handleCloseLang}
                onClick={handleCloseLang}
                transformOrigin={{horizontal: 'right', vertical: 'top'}}
                anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            >
                <MenuItem onClick={() => {
                    handleChangeLang('en')
                }}>
                    <GB style={{borderRadius: '50%'}} title={'English'} width={20} height={20}/>
                </MenuItem>
                <MenuItem onClick={() => {
                    handleChangeLang('it')
                }}>
                    <IT style={{borderRadius: '50%'}} title={'Italiano'} width={20} height={20}/>
                </MenuItem>
                <MenuItem onClick={() => {
                    handleChangeLang('fr')
                }}>
                    <FR style={{borderRadius: '50%'}} title={'Francese'} width={20} height={20}/>
                </MenuItem>
                <MenuItem onClick={() => {
                    handleChangeLang('es')
                }}>
                    <ES style={{borderRadius: '50%'}} title={'Español'} width={20} height={20}/>
                </MenuItem>
                <MenuItem onClick={() => {
                    handleChangeLang('pt')
                }}>
                    <PT style={{borderRadius: '50%'}} title={'Português'} width={20} height={20}/>
                </MenuItem>
            </Menu>
        </Box>
    );
}

export default Header;
